/*
 * @Author: zhengxiaowen
 * @Date: 2018-10-10 20:55:03
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-22 10:26:20
 */

// *** 框架 start ***
import RNDemo from './demo/config/router'
import { isLoggedIn, srmLoginRedirect } from '@/utils/authRoute'
// *** 框架 end ***

// *** 业务模块 start ***

// *** 业务模块 end ***

let router = [
  {
    path: '/',
    redirect: (to) => {
      if (!isLoggedIn()) return srmLoginRedirect(to)
      return '/TabPage'
    },
  },
  {
    path: '/login',
    redirect: (to) => srmLoginRedirect(to),
  },
]

router = router.concat(RNDemo)

// *** 业务模块 start ***

// *** 业务模块 end ***

export default router



// WEBPACK FOOTER //
// ./src/page/routerPage.js